export enum DisplayStatus {
  COMING_SOON = 0,
  HIDE = 1,
  CONTINUE_AS_USUAL = 2,
  SIGN_IN_REQUIRED = 3,
  PAYMENT_REQUIRED = 4,
  SIGN_IN_AND_PAYMENT_REQUIRED = 5,
}
